// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/pits",
  Create: "/pyr/pits",
  Update: "/pyr/pits",
  Delete: "/pyr/pits",
};
